import { render, staticRenderFns } from "./serviceCard.vue?vue&type=template&id=ef3d4376&scoped=true"
import script from "./serviceCard.vue?vue&type=script&lang=js"
export * from "./serviceCard.vue?vue&type=script&lang=js"
import style0 from "./serviceCard.vue?vue&type=style&index=0&id=ef3d4376&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3d4376",
  null
  
)

export default component.exports